import React from 'react';

import { getIconSvg } from 'utils/svg';
import { Title } from 'components/common/Title';
import { ApiError } from 'services/restService';
import { DetailBox } from 'components/common/DetailBox';
import { stepStyles  } from 'components/steps/commonStyles';

export interface FailProps {
	error: ApiError;
	title: string;
	detail: string;
	className?: string;
}

export const Fail = ({ error, title, detail, className }: FailProps) => {
	return (
		<div className={className}>
			<Title>{title}</Title>
			<p className={stepStyles.formElement}>{detail}</p>
			<DetailBox error={error}/>
			<img alt="desk" className={stepStyles.groundImg} src={getIconSvg('desk', 'images')} />
		</div>
	);
};
